<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [callbackFunction]="chartCallback"
  style="height: 350px; width: 100%; display: block;">
</highcharts-chart>
